import * as ACTION_TYPES from './actiontypes';
import { CRITERIA_ITEM_TYPES } from './hook';

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_CODERS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        statusMessage: 'Getting coders for contract',
        selectedCriteria: {
          [CRITERIA_ITEM_TYPES.WORKFLOW_STEP]: [],
          [CRITERIA_ITEM_TYPES.AUDITED_BY]: [],
          [CRITERIA_ITEM_TYPES.FINALIZED_BY]: [],
          [CRITERIA_ITEM_TYPES.ONHOLD_BY]: []
        }
      };
    }

    case ACTION_TYPES.GET_CODERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.GET_CODERS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.SEARCH_REQUEST: {
      return {
        ...state,
        isLoading: true,
        statusMessage: 'Searching for encounters'
      };
    }

    case ACTION_TYPES.SEARCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        isLoading: false,
        statusMessage: '',
        searchResults: payload.results
      };
    }

    case ACTION_TYPES.SEARCH_FAILURE: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.SELECT_CRITERIA_ITEM: {
      const { payload } = action;

      const isSameId = x => (x === payload.itemId || x == payload.itemId);
      const isDupe =
        state.selectedCriteria[payload.itemType].filter(isSameId).length > 0;

      const nextSelectedCriteria = {
        ...state.selectedCriteria,
        [payload.itemType]: isDupe === true
          ? [...state.selectedCriteria[payload.itemType]]
          : [
            ...state.selectedCriteria[payload.itemType],
            payload.itemId
          ]
      };

      return {
        ...state,
        isLoading: false,
        statusMessage: '',
        selectedCriteria: nextSelectedCriteria
      };
    }

    case ACTION_TYPES.REMOVE_CRITERIA_ITEM: {
      const { payload } = action;

      const nextSelectedCriteria = {
        ...state.selectedCriteria,
        [payload.itemType]:
          state.selectedCriteria[payload.itemType].filter(x =>
            x !== payload.itemId
          )
      };

      return {
        ...state,
        isLoading: false,
        statusMessage: '',
        selectedCriteria: nextSelectedCriteria
      };
    }

    case ACTION_TYPES.CHANGE_INPUT_VALUE: {
      const { payload: { name, type, value } } = action;

      return {
        ...state,
        inputs: {
          ...state.inputs,
          [type]: {
            ...state.inputs[type],
            [name]: value
          }
        }
      };
    }

    case ACTION_TYPES.INIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        statusMessage: 'Initializing page'
      };
    }

    case ACTION_TYPES.INIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.INIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    default: {
      throw Error('useReviewSearch reducer should never hit default case');
    }
  }
};

export default reducer;
